import { call, select, takeEvery } from 'redux-saga/effects';
import { get } from 'lodash';

import { WorkflowUrls } from 'config/urls';
import { WorkflowConstants } from 'constants/workflowConstants';
import { request } from 'components/Request';

function* addActivityToAction(action) {
  const { skipActivityCheck } = action.payload;
  const activity = yield select((state) => get(state, 'workflow.activity'));
  if (activity && !skipActivityCheck) {
    return { ...action, payload: { ...action.payload, data: { ...action.payload.data, activity } } };
  }
  return action;
}

function* startSaga(action) {
  yield call(request({
    type: WorkflowConstants.START_ACTION,
    method: 'POST',
    url: WorkflowUrls.start(),
  }), action);
}

function* checkinSaga(action) {
  const actionWithActivity = yield call(addActivityToAction, action);
  yield call(request({
    type: WorkflowConstants.CHECKIN_ACTION,
    method: 'PUT',
    url: WorkflowUrls.checkin(action.payload.key),
  }), actionWithActivity);
}

function* nextSaga(action) {
  const actionWithActivity = yield call(addActivityToAction, action);
  yield call(request({
    type: WorkflowConstants.NEXT_ACTION,
    method: 'PUT',
    url: WorkflowUrls.next(action.payload.key),
  }), actionWithActivity);
}

function* backSaga(action) {
  const actionWithActivity = yield call(addActivityToAction, action);
  yield call(request({
    type: WorkflowConstants.BACK_ACTION,
    method: 'PUT',
    url: WorkflowUrls.back(action.payload.key),
  }), actionWithActivity);
}

function* redirectSaga(action) {
  yield call(request({
    type: WorkflowConstants.REDIRECT_ACTION,
    method: 'PUT',
    url: WorkflowUrls.redirect(action.payload.token),
  }), action);
}

function* getRedirectDataSaga(action) {
  yield call(request({
    type: WorkflowConstants.GET_REDIRECT_DATA_ACTION,
    method: 'GET',
    url: WorkflowUrls.redirect(action.payload.token),
  }), action);
}

function* validateRoutingNumberSaga(action) {
  yield call(request({
    type: WorkflowConstants.VALID_ROUTING_NUMBER,
    method: 'GET',
    url: WorkflowUrls.validateRoutingNumber(action.payload.routingNumber),
  }), action);
}

function* getLTVOptions(action) {
  yield call(request({
    type: WorkflowConstants.GET_LTV_OPTIONS,
    method: 'POST',
    url: WorkflowUrls.getLTVOptions(),
  }), action);
}

function* uploadImageToPreSignedUrlSaga(action) {
  const { url } = action.payload;
  yield call(request({
    type: WorkflowConstants.UPLOAD_IMAGE_TO_PRESIGNED_URL,
    method: 'PUT',
    url,
    headers: {
      'Content-Type': 'image/*',
    },
  }), action);
}

function* getIPAddress(action) {
  yield call(request({
    type: WorkflowConstants.GET_IP_ADDRESS,
    method: 'GET',
    nullData: true,
    apiUrl: 'https://api.ipify.org?format=json&callback=?',
  }), action);
}

function* resumeApplicationSaga(action) {
  const { key, activity } = action.payload;
  yield call(request({
    type: WorkflowConstants.RESUME_APPLICATION,
    method: 'PUT',
    url: WorkflowUrls.resumeApplication(key, activity),
  }), action);
}

function* selectOfferSaga(action) {
  const { key, activity } = action.payload;
  yield call(request({
    type: WorkflowConstants.SELECT_OFFER,
    method: 'PUT',
    url: WorkflowUrls.checkin(key, activity),
  }), action);
}

const WorkflowSaga = function* () {
  yield takeEvery(WorkflowConstants.START_ACTION, startSaga);
  yield takeEvery(WorkflowConstants.CHECKIN_ACTION, checkinSaga);
  yield takeEvery(WorkflowConstants.NEXT_ACTION, nextSaga);
  yield takeEvery(WorkflowConstants.BACK_ACTION, backSaga);
  yield takeEvery(WorkflowConstants.REDIRECT_ACTION, redirectSaga);
  yield takeEvery(WorkflowConstants.GET_REDIRECT_DATA_ACTION, getRedirectDataSaga);
  yield takeEvery(WorkflowConstants.VALID_ROUTING_NUMBER, validateRoutingNumberSaga);
  yield takeEvery(WorkflowConstants.GET_LTV_OPTIONS, getLTVOptions);
  yield takeEvery(WorkflowConstants.UPLOAD_IMAGE_TO_PRESIGNED_URL, uploadImageToPreSignedUrlSaga)
  yield takeEvery(WorkflowConstants.GET_IP_ADDRESS, getIPAddress);
  yield takeEvery(WorkflowConstants.RESUME_APPLICATION, resumeApplicationSaga);
  yield takeEvery(WorkflowConstants.SELECT_OFFER, selectOfferSaga);
};

export default WorkflowSaga;
